import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { lazy } from 'react';
import { readConfObject } from '@jbrowse/core/configuration';
import { getSession, isSessionWithAddTracks } from '@jbrowse/core/util';
var ConfirmDialog = lazy(function () {
  return import('./ConfirmDialog');
});
export default function (pm) {
  pm.addToExtensionPoint('TrackSelector-multiTrackMenuItems', function (items, props) {
    var session = props.session;
    return [].concat(_toConsumableArray(items), _toConsumableArray(isSessionWithAddTracks(session) ? [{
      label: 'Create multi-wiggle track',
      onClick: function onClick(model) {
        var tracks = model.selection;
        var trackIds = tracks.map(function (c) {
          return readConfObject(c, 'name');
        });
        function makeTrack(arg) {
          var subadapters = tracks.map(function (c) {
            return readConfObject(c, 'adapter');
          }).map(function (c, idx) {
            return _objectSpread({}, c, {
              source: trackIds[idx]
            });
          });
          var assemblyNames = _toConsumableArray(new Set(tracks.map(function (c) {
            return readConfObject(c, 'assemblyNames');
          }).flat()));
          var now = +Date.now();
          var trackId = "multitrack-".concat(now, "-sessionTrack");
          getSession(model).addTrackConf({
            type: 'MultiQuantitativeTrack',
            trackId: trackId,
            name: arg.name,
            assemblyNames: assemblyNames,
            adapter: {
              type: 'MultiWiggleAdapter',
              subadapters: subadapters
            }
          });
          model.view.showTrack(trackId);
        }
        getSession(model).queueDialog(function (handleClose) {
          return [ConfirmDialog, {
            tracks: tracks,
            onClose: function onClose(arg, arg1) {
              if (arg && arg1) {
                makeTrack(arg1);
              }
              handleClose();
            }
          }];
        });
      }
    }] : []));
  });
}